






























































































































// vendor
import { defineComponent, ref, computed, watch } from "@vue/composition-api";
import { format as formatDate } from "date-fns";
// project
import { Asset } from "@/psychlab/types";
import * as StudyAPI from "@/services/api/studies";
import { IconCardGrid } from "@/components.generic/icon-card-grid";
import { TagSidebar } from "@/components.tags/tag-sidebar";
import { getInverseColor } from "@/utils/color";
import { useTags } from "@/hooks/useTags";
import { useAssets } from "@/hooks/useAssets";
import { sortByDate } from "@/utils/array";
import { StudyList } from "@/components.studies/study-list";
import { CreateStudyWizard, ICreateStudyWizard } from "@/components.studies/create-study-wizard";
import { getAssetTypes } from "@/psychlab/meta";

import { useTranslate } from "@lang";



export default defineComponent({
	props:{
		searchFilter:{
			type:String,
			default:"",
		},
	},
	components: {
		IconCardGrid,
		TagSidebar,
		StudyList,
		CreateStudyWizard,
	},
	setup(props, context){

		const createStudyWizard = ref<ICreateStudyWizard>();
		const studiesList = ref<any>();

		const { translate } = useTranslate();

		const { assets } = useAssets();

		const { sortedTags, hasTag, } = useTags();

		const iconColor = computed(() => {
			return getAssetTypes().find(a => a.name === "Graph")?.color || "white";
		});

		const filterAsset = (a:Asset) => {
			if(a.type !== "Graph"){ return false; }
			if(!props.searchFilter || props.searchFilter.length < 2){ return true; }
			return a.name.toLowerCase().includes(props.searchFilter.toLowerCase());
		};

		const blueprints = computed(() => {
			const tag = currentTagId.value;
			const blueprints = assets.value.filter(filterAsset);
			sortByDate(blueprints, a => a.lastModified);
			if(!tag){ return blueprints; }
			return blueprints.filter(bp => hasTag(tag, bp._id));
		});

		const currentTagId = ref<string|null>(null);

		const currentTag = computed(() => {
			return sortedTags.value.find(t => t._id === currentTagId.value);
		});
		
		const getBlueprintRoute = (blueprintId:string) => {
			return {
				name: "Run.Study",
				params:{
					studyId:blueprintId
				},
				query:{
					...context.root.$route.query
				}
			}
		};

		const setCurrentTag = (v:string) => {
			currentTagId.value = v;
		};

		const createStudy = (blueprintId:string) => {
			if(!createStudyWizard.value){ return; }
			createStudyWizard.value.open({
				blueprint:blueprintId,
			}, async (r:any) => {
				const { name, study, version, language, openDashboard } = r;
				const s = await StudyAPI.createStudy({ name, blueprint:`${study}@${version}`, language });
				if(studiesList.value){
					studiesList.value.refresh();
				}

				if(openDashboard){
					context.root.$router.push({
						name:"Run.Group",
						params:{
							groupId:s._id,
						}
					});
				}

			});
		};

		const getFormattedDate = (date:string) => {
			return formatDate(new Date(date), "EEE MMM. d y @ HH:mm")
		};

		const init = async() => {
			const t = context.root.$route.query["t"];
			if(t && typeof(t) === "string"){
				currentTagId.value = t;
			}
		};

		watch(() => context.root.$route.query["t"], v => {
			if(currentTagId.value !== v){
				setCurrentTag(v as any);
			}
		});


		init();

		return {
			iconColor,
			createStudyWizard,
			blueprints,
			currentTagId,
			currentTag,
			getBlueprintRoute,
			setCurrentTag,
			getInverseColor,
			createStudy,
			studiesList,
			getFormattedDate,
			translate,
		};

	}

});
